import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import TableComponent from '~/components/TableComponent'
import { StockExchangeQuery } from '~/QueryHooks/StockExchangeQuery'
import { RouteTypes } from '~/routes/constants'
import ShowStoneXBle from './ShowStoneXBle'
import Dialog from '~/components/Dialog'
import { handleErrors } from '~/utils/helpers'
import StockExChangeService from '~/api/services/stockExchange'
import notify from '~/components/Notify'

const StoneXBle:React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [dataFiltered, setDataFiltered] = useState({
    rows: 20,
    page: 0
  })
  const [contractId, setContractId] = useState(null)
  const [deleteContractId, setDeleteContractId] = useState(null)
  const [isLoadingDelete, setIsLoadingDelete] = useState(false)

  const tableColumnHeaders = [
    {
      name: 'Handelsmonat',
      key: 'tradingMonth',
      type: 'dateRibbon',
      format: 'DD.MM.YYYY'
    },
    {
      name: 'Handels-Slot',
      key: 'uniqueId'
    },
    {
      name: 'Kontrakt-ID',
      key: 'contractId'
    },
    {
      name: 'Kontraktabschluss',
      key: 'contractConclusionDate',
      type: 'date',
      format: 'DD.MM.YYYY'
    },
    {
      name: 'Anzahl Kontrakte',
      key: 'numberOfContracts'
    },
    {
      name: 'Kontraktmenge (in kg)',
      key: 'contractAmount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: 'Glattstellung',
      key: 'appliedOn',
      type: 'date',
      format: 'DD.MM.YYYY'
    },
    {
      name: t('Actions')
    }
  ]

  const actions = [
    {
      popupMessage: 'Details',
      type: 'icon',
      name: 'eye',
      size: 'large',
      actionType: 'show'
    },
    {
      popupMessage: t('Edit'),
      type: 'link',
      name: 'pencil',
      size: 'large',
      link: RouteTypes.DAIRY_FACTORY_STONE_X_BLE_EDIT,
      disableForLightUser: true
    },
    {
      popupMessage: t('Delete'),
      type: 'icon',
      name: 'trash',
      size: 'large',
      actionType: 'delete',
      disableForLightUser: true
    }
  ]

  const {
    data: contracts,
    isLoading: isLoadingContracts,
    isFetching: isFetchingContracts,
    refetch: fetchContracts
  } = StockExchangeQuery.getStonexContracts({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    fetchContracts()
  }, [dataFiltered, t])

  function renderActions() {
    return <El.PageHeaderActionButton
      onClick={() => navigate(RouteTypes.DAIRY_FACTORY_STONE_X_BLE_CREATE)}>
      {'Kontrakt hinzufügen'}
    </El.PageHeaderActionButton>
  }

  function handleClickAction(row, type) {
    switch (type) {
      case 'show':
        return setContractId(row?.id)
      case 'delete':
        return setDeleteContractId(row?.id)
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      animated
      actions={actions}
      isFetchingData={isFetchingContracts}
      handleClickAction={handleClickAction}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => {
        setDataFiltered(data)
      }}
      rows={rows}
      total={filtered}
    />
  }

  function renderShowDrawer() {
    return <ShowStoneXBle
      contractId={contractId}
      handleHiddenDrawer={() => setContractId(null)}
    />
  }

  async function handleDeleteContract() {
    setIsLoadingDelete(true)
    try {
      await StockExChangeService.deleteStoneXContract(deleteContractId)
      notify(t('Successfully delete BLE contract'), 'success')
      setDeleteContractId(null)
      fetchContracts()
    } catch(error) {
      handleErrors(error)
    }
    setIsLoadingDelete(false)
  }

  function renderDeleteModal() {
    return <Dialog
      type={'abort'}
      isDialogOpen={Boolean(deleteContractId)}
      isLoading={isLoadingDelete}
      handleClose={() => setDeleteContractId(null)}
      textContent={t('Are you sure you want to delete contract?')}
      textHeader={t('Delete contract')}
      textSubmit={t('Delete')}
      textClose={t('Cancel')}
      handleSubmit={() => handleDeleteContract()}
    />
  }

  const { filtered, rows } = contracts ? contracts : { filtered: 0, rows: [] };

  return <Layout
    title={t('StoneX BLE Cash S.')}
    isBusy={isLoadingContracts}
    segmented
    actions={renderActions()}
  >
    {renderDeleteModal()}
    {renderShowDrawer()}
    {renderTable()}
  </Layout>
}
export default StoneXBle